<template>
  <div class="flex items-center rounded-xl relative border bg-gray-50 dark:bg-gray-950/50 hover:scale-102 transition-all">
    <slot>
      <div class="p-3 pr-2">
        <div class="h-8 w-8 rounded-xl bg-primary-100 flex items-center justify-center text-primary-600 dark:bg-primary-500/20 flex-shrink-0">
          <o-icon :icon="icon" />
        </div>
      </div>
    </slot>

    <div class="p-3">
      <p class="text-xs opacity-70">
        {{ type }}
      </p>
      <p class="font-semibold text-sm opacity-90">
        {{ title }}
      </p>
      <p v-if="info" class="text-sm opacity-90">
        {{ info }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  type: string
  title: string
  info?: string | null
  icon?: string | null
}

withDefaults(defineProps<Props>(), {
  info: null,
  icon: null,
})
</script>
